import axiosHttp from "./interceptor.service";

const addDocument = (data) => {
    return axiosHttp.post("/lmt/employeeDocument", data);
};

const getDocumentsByEmployeeId = (employeeId) => {
    return axiosHttp.get(`/lmt/employeeDocument/${employeeId}`);
};

export { addDocument, getDocumentsByEmployeeId };
